// Dependency-free media release validation shared by the editor and callable.
const MAX_PRICE = BigInt(Number.MAX_SAFE_INTEGER) - 10000000n;
function mediaMintSettingsIssues(settings = {}) {
    const issues = [];
    const add = (field, message) => issues.push({ field, message });
    if ((settings.assetStandard || 'CORE') !== 'CORE') add('assetStandard', 'Media minting supports Core NFTs only.');
    if (typeof settings.name !== 'string' || !settings.name.trim() || settings.name.length > 100) {
        add('name', 'Enter an NFT name of 1-100 characters.');
    }
    if (settings.description != null && (typeof settings.description !== 'string' || settings.description.length > 4000)) {
        add('description', 'Keep the NFT description within 4000 characters.');
    }
    const mode = settings.editionMode || 'LIMITED';
    if (!['LIMITED', 'OPEN'].includes(mode)) add('editionMode', 'Choose open or limited editions.');
    if (mode === 'LIMITED' && (!/^\d+$/.test(String(settings.supply ?? ''))
        || !Number.isSafeInteger(Number(settings.supply)) || Number(settings.supply) < 1 || Number(settings.supply) > 1000000)) {
        add('supply', 'Enter a whole edition supply from 1 to 1000000.');
    }
    const price = settings.priceAmount;
    let validPrice = typeof price === 'string' && /^\d{1,16}(\.\d{1,9})?$/.test(price);
    if (validPrice) {
        const [whole, fraction = ''] = price.split('.');
        const atomic = BigInt(whole + fraction.padEnd(9, '0'));
        validPrice = atomic > 0n && atomic <= MAX_PRICE;
    }
    if (!validPrice) add('priceAmount', 'Enter a positive SOL price with at most 9 decimal places (maximum 9007199.244740991 SOL).');
    if (settings.collectionId != null && (typeof settings.collectionId !== 'string'
        || settings.collectionId !== '' && !/^[a-zA-Z0-9_-]{1,128}$/.test(settings.collectionId))) {
        add('collectionId', 'Choose a collection or No collection.');
    }
    if (!['SPACE', 'ARCHIVE'].includes(settings.mediaStorage || 'ARCHIVE')) add('mediaStorage', 'Choose MuultiSpace storage or archival.');
    if (!['IRYS', 'ARWEAVE', 'IPFS'].includes(settings.archiveProvider)) add('archiveProvider', 'Choose Irys, Arweave or IPFS for NFT metadata.');
    if (!['ARCHIVE_NOW', 'ARCHIVE_ON_FIRST_MINT'].includes(settings.archiveStrategy)) add('archiveStrategy', 'Choose when to archive the NFT.');
    const link = settings.externalUrl ?? '';
    let validLink = typeof link === 'string' && link.length <= 2048;
    if (validLink && link.trim()) {
        try { validLink = /^https?:\/\//.test(link.trim()) && !!new URL(link.trim()).hostname; } catch { validLink = false; }
    }
    if (!validLink) add('externalUrl', 'Use a complete HTTP or HTTPS external link of at most 2048 characters.');
    const attributes = settings.attributes ?? [];
    if (!Array.isArray(attributes) || attributes.length > 100) add('attributes', 'Use at most 100 NFT attributes.');
    else attributes.forEach((attribute, index) => {
        const name = attribute?.trait_type || attribute?.name;
        const value = attribute?.value;
        if (typeof name !== 'string' || !name.trim() || name.length > 128) {
            add('attributes', `Enter a name of 1-128 characters for attribute ${index + 1}, or remove it.`);
        }
        if (!(typeof value === 'string' && value.length <= 2048 || typeof value === 'boolean'
            || typeof value === 'number' && Number.isFinite(value))) {
            add('attributes', `Use text (up to 2048 characters), a number, or a boolean for attribute ${index + 1}.`);
        }
    });
    return issues;
}
function mediaMintSource(component) {
    if (component?.type === 'image') {
        const images = Array.isArray(component.images) && component.images.length ? component.images : [{ url: component.url }];
        const image = images[0];
        const url = typeof image === 'string' ? image : image?.url || image?.imageUrl;
        return { url: url || '', imageUrl: url || '', category: 'image' };
    }
    if (component?.type === 'audio') return { url: component.audioUrl || component.url || '', imageUrl: component.cover || component.coverUrl || '', category: 'audio' };
    return { url: component?.url || '', imageUrl: component?.featureImageUrl || component?.coverUrl || '', category: 'video' };
}
function mediaMintSourceIssues(component) {
    if (!['image', 'audio', 'video'].includes(component?.type)) return [{ field: 'media', message: 'Choose an image, audio, or video panel.' }];
    if (component.type === 'image' && component.images?.length > 1) {
        return [{ field: 'media', message: 'Minting requires a single media item. Remove the additional images or turn off minting.' }];
    }
    const issues = [];
    const source = mediaMintSource(component);
    if (typeof source.url !== 'string' || !source.url.trim()) issues.push({ field: 'media', message: 'Save the media file before publishing its NFT.' });
    if (component.type !== 'image' && (typeof source.imageUrl !== 'string' || !source.imageUrl.trim())) {
        issues.push({ field: 'preview', message: 'Add and save preview artwork for this audio or video NFT.' });
    }
    return issues;
}
module.exports = { MAX_PRICE, mediaMintSettingsIssues, mediaMintSource, mediaMintSourceIssues };
